import type { CreateDonationBasketCommand } from '../../models/donation/createDonationBasketCommand';
import { requests } from '../httpClient';

export const Donations = {
    getCommitmentsAsync: () => requests.get(`Donations/Commitments`),
    submitToBasketAsync: (donationCommand: CreateDonationBasketCommand) => requests.post(`Donations/Basket`, donationCommand)
};
